import image1 from '../assets/mediaConfigImage1.jpg';
import image2 from '../assets/mediaConfigImage2.jpg';
import image3 from '../assets/mediaConfigImage3.jpg';
import image4 from '../assets/mediaConfigImage4.jpg';
import image5 from '../assets/mediaConfigImage5.jpg';
import image6 from '../assets/mediaConfigImage6.jpg';
import image7 from '../assets/mediaConfigImage7.jpg';
import image8 from '../assets/mediaConfigImage8.jpg';
import image9 from '../assets/mediaConfigImage9.jpg';
import image10 from '../assets/mediaConfigImage10.jpg';
import image11 from '../assets/mediaConfigImage11.jpg';
import image12 from '../assets/mediaConfigImage12f.jpg';
import image13 from '../assets/mediaConfigImage13.jpg';
import image14 from '../assets/mediaConfigImage14f.jpg';
import image15 from '../assets/mediaConfigImage15.jpg';
import image16 from '../assets/mediaConfigImage16.jpg';
import image17 from '../assets/mediaConfigImage17f.png';
import image18 from '../assets/mediaConfigImage18.jpg';
import image19 from '../assets/mediaConfigImage19.jpg';
import image20 from '../assets/mediaConfigImage20f.jpg';
import image21 from '../assets/mediaConfigImage21.jpg';
import image22 from '../assets/mediaConfigImage22f.jpg';

export const mediaConfig = {
      heading: "Our Media",
      subheading: "CHECK US OUT",
      buttonText: "View More",
      images: [
        image1,
        image2,
        image3,
        image4,
        image5,
        image6,
        image7,
        image8
        // image9,
        // image10,
        // image11,
        // image12,
        // image14,
        // image15,
        // image16,
        // image17,
        // image18,
        // image19,
        // image20
      ]
    };